var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88886 2.05556C2.31842 2.05556 2.66664 1.70733 2.66664 1.27778C2.66664 0.848223 2.31842 0.5 1.88886 0.5C1.45931 0.5 1.11108 0.848223 1.11108 1.27778C1.11108 1.70733 1.45931 2.05556 1.88886 2.05556Z",
    fill: "#154365",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11108 2.05556C8.54064 2.05556 8.88886 1.70733 8.88886 1.27778C8.88886 0.848223 8.54064 0.5 8.11108 0.5C7.68153 0.5 7.33331 0.848223 7.33331 1.27778C7.33331 1.70733 7.68153 2.05556 8.11108 2.05556Z",
    fill: "#154365",
    fillOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88886 8.27778C2.31842 8.27778 2.66664 7.92955 2.66664 7.5C2.66664 7.07045 2.31842 6.72222 1.88886 6.72222C1.45931 6.72222 1.11108 7.07045 1.11108 7.5C1.11108 7.92955 1.45931 8.27778 1.88886 8.27778Z",
    fill: "#154365",
    fillOpacity: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11108 8.27778C8.54064 8.27778 8.88886 7.92955 8.88886 7.5C8.88886 7.07045 8.54064 6.72222 8.11108 6.72222C7.68153 6.72222 7.33331 7.07045 7.33331 7.5C7.33331 7.92955 7.68153 8.27778 8.11108 8.27778Z",
    fill: "#154365",
    fillOpacity: 0.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88886 14.5C2.31842 14.5 2.66664 14.1518 2.66664 13.7222C2.66664 13.2927 2.31842 12.9444 1.88886 12.9444C1.45931 12.9444 1.11108 13.2927 1.11108 13.7222C1.11108 14.1518 1.45931 14.5 1.88886 14.5Z",
    fill: "#154365",
    fillOpacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11108 14.5C8.54064 14.5 8.88886 14.1518 8.88886 13.7222C8.88886 13.2927 8.54064 12.9444 8.11108 12.9444C7.68153 12.9444 7.33331 13.2927 7.33331 13.7222C7.33331 14.1518 7.68153 14.5 8.11108 14.5Z",
    fill: "#154365",
    fillOpacity: 0.08
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88886 2.05556C2.31842 2.05556 2.66664 1.70733 2.66664 1.27778C2.66664 0.848223 2.31842 0.5 1.88886 0.5C1.45931 0.5 1.11108 0.848223 1.11108 1.27778C1.11108 1.70733 1.45931 2.05556 1.88886 2.05556Z",
    stroke: "#154365",
    strokeOpacity: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11108 2.05556C8.54064 2.05556 8.88886 1.70733 8.88886 1.27778C8.88886 0.848223 8.54064 0.5 8.11108 0.5C7.68153 0.5 7.33331 0.848223 7.33331 1.27778C7.33331 1.70733 7.68153 2.05556 8.11108 2.05556Z",
    stroke: "#154365",
    strokeOpacity: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88886 8.27778C2.31842 8.27778 2.66664 7.92955 2.66664 7.5C2.66664 7.07045 2.31842 6.72222 1.88886 6.72222C1.45931 6.72222 1.11108 7.07045 1.11108 7.5C1.11108 7.92955 1.45931 8.27778 1.88886 8.27778Z",
    stroke: "#154365",
    strokeOpacity: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11108 8.27778C8.54064 8.27778 8.88886 7.92955 8.88886 7.5C8.88886 7.07045 8.54064 6.72222 8.11108 6.72222C7.68153 6.72222 7.33331 7.07045 7.33331 7.5C7.33331 7.92955 7.68153 8.27778 8.11108 8.27778Z",
    stroke: "#154365",
    strokeOpacity: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88886 14.5C2.31842 14.5 2.66664 14.1518 2.66664 13.7222C2.66664 13.2927 2.31842 12.9444 1.88886 12.9444C1.45931 12.9444 1.11108 13.2927 1.11108 13.7222C1.11108 14.1518 1.45931 14.5 1.88886 14.5Z",
    stroke: "#154365",
    strokeOpacity: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11108 14.5C8.54064 14.5 8.88886 14.1518 8.88886 13.7222C8.88886 13.2927 8.54064 12.9444 8.11108 12.9444C7.68153 12.9444 7.33331 13.2927 7.33331 13.7222C7.33331 14.1518 7.68153 14.5 8.11108 14.5Z",
    stroke: "#154365",
    strokeOpacity: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.0f3cf87fdaabd73f58b97b9a24304bf8.svg";
export { ForwardRef as ReactComponent };